$(document).ready(function () {
  var $storedJson = {};

  $(document).on("click", ".related_option_size", function () {
    $arr_options = get_total_options($(this));

    if (jQuery.inArray("size", $arr_options) != -1) {
      // code for check option size checked
      $(".related_option_size").removeAttr("checked");
      $(this).attr("checked", "checked");
      $(this).prop("checked", true);
      changeVariationId($(this));
    }
  });

  $(document).on("click", ".related_option_colors", function () {
    $arr_options = get_total_options($(this));

    if (jQuery.inArray("colors", $arr_options) != -1) {
      // code for check option color checked
      $(".related_option_colors").removeAttr("checked");
      $(this).attr("checked", "checked");
      $(this).prop("checked", true);
      changeVariationId($(this));
    }
  });

  $(document).on("click", ".related_option_sizerange", function () {
    $arr_options = get_total_options($(this));

    if (jQuery.inArray("colors", $arr_options) != -1) {
      // code for check option color checked
      $(".related_option_sizerange").removeAttr("checked");
      $(this).attr("checked", "checked");
      $(this).prop("checked", true);
      changeVariationId($(this));
    }
  });

  $(document).on("click", ".add_to_bag_related_product_variation", function () {
    $(this)
      .closest("div.card__content")
      .find("form.related_variation_form")
      .submit();
  });

  function changeVariationId($that) {
    var $colorVal = $that
      .closest("form.related_variation_form")
      .find("input[type=radio].related_option_colors:checked")
      .val()
      .toLowerCase();

    var $sizeVal = $that
      .closest("form.related_variation_form")
      .find("input[type=radio].related_option_size:checked")
      .val()
      .toLowerCase();

    var $getJson = getWholeJsonValue($that);
    var $perOptionJson = parseVarIdOptions($getJson);

    $.each($perOptionJson, function (key, val) {
      $loopColor = val[1];
      $loopSize = val[2];
      $loopVariationId = val[0];
      $loopFeaturedImage = val[3];

      if ($loopColor === $colorVal && $loopSize === $sizeVal) {
        var $thatImg = $that.closest("li.grid__item").find("img");

        var $thatFeaturedImg = $that
          .closest("li.grid__item")
          .find("input.stored_main_related_product_image")
          .val();

        if ($loopFeaturedImage !== "null") {
          $thatImg.attr("src", $loopFeaturedImage);
          $thatImg.attr("srcset", $loopFeaturedImage);
        } else {
          $thatImg.attr("src", $thatFeaturedImg);
          $thatImg.attr("srcset", $thatFeaturedImg);
        }

        $that
          .closest("form.related_variation_form")
          .find("input[type=hidden].id_variation")
          .val($loopVariationId);
      }
    });
  }

  function getWholeJsonValue($that) {
    var $sizeVal = $that
      .closest("form.related_variation_form")
      .find("input[type=hidden].all_variation_json")
      .val();

    return $sizeVal;
  }

  function parseVarIdOptions($wholeString) {
    var $returnParams = {};
    var $perVariation = $wholeString.split("|");

    $.each($perVariation, function (key, perValue) {
      var $splitValue = perValue.split("<->");
      $returnParams[key] = $splitValue;
    });

    return $returnParams;
  }

  function get_total_options($that) {
    const $str = $that
      .closest("form.related_variation_form")
      .find("input[type=hidden].all_option_name")
      .val();

    const $filterStr = $str.replace(/,(\s+)?$/, "");

    const $arr = $filterStr.split(",");

    return $arr;
  }
});
